/*
*###############################################################################
*Module Name                   : ScaleDataPrint.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Isuru Sampath Arandara                        #
*Date                          : Friday, February 02nd 2024, 9:18:43 Am        #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState, useEffect, useContext, useRef } from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPInfoBox from "framework/layout/DPInfoBox"
import DPPermission from "framework/widgets/DPPermission"
import DPLoadingAlert from "framework/widgets/DPLoadingAlert"

// Worse way
import DPPrintOption from "framework/widgets/DPPrintOptions"
// Better way to reduce bundle size
//import BarWave from "react-cssfx-loading/lib/BarWave";

import { Context } from "../../../app-contexts/CommonContexts"
import { useHistory } from "react-router-dom"
import TransactionGenerateTXNWithExcelContent from "./TransactionGenerateTXNWithExcelContent"
import { GetUserWiseLocations, handleUpload } from "./TransactionGenerateTXNWithExcelController"


const TransactionGenerateTXNWithExcel = props => {
  let history = useHistory()

  const {
    isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
  } = useContext(Context);


  const [file, setFile] = useState(null);
  const inputref = useRef(null);
  const [selectedLocation, setSelectedLocation] = useState("")
  const [locationList, setLocationList] = useState([])
  const [referenceNo, setReferenceNo] = useState("")
  const [referenceType, setReferenceType] = useState("")


  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [disabled, setDisabled] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)

  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [menuCode, SetMenuCode] = useState("")

  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [ErrorMsg, setErrorMsg] = useState("")
  const [addNew, SetAddNew] = useState(true)
  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")

  const [Location, setLocation] = useState("")

  const [ShowReason, setShowReason] = useState(false)
  const [LogUsercompany, setLogUsercompany] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  //*****Menu Rights End */

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  const [Reason, setReason] = useState("Created")

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)
  const [helpUrl, setHelpUrl] = useState("")


  const [mainExtCode, setMainExtCode] = useState("");
  const extCode = [
    { label: "CSV", value: "csv" },
    { label: "XLS", value: "xls" },
    { label: "XLSX", value: "xlsx" },
    { label: "XML", value: "xml" },
    { label: "Text", value: "txt" },
  ];

  //import from contexts

  var time = process.env.REACT_APP_ALERTTIMEOUT


  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")


  //**Get File Details */
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var Location = obj[3]
    var LogUsercompany = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    setLocation(Location)
    setLogUsercompany(LogUsercompany)
    setLogUserType(LogUserType)

    var responseData = await getSelectedMasterPermissions(LogUserType, menu)


    if (!responseData.strMenuAccessRight) {
      history.push('/dashboard')
    }

    SetMenuAccess(responseData.strMenuAccessRight)
    SetMenuCreate(responseData.strMenuCreateRight)
    SetMenuDelete(responseData.strMenuDeleteRight)
    SetMenuModify(responseData.strMenuModifyRight)
    SetMenuPrint(responseData.strMenuPrintRight)
    SetMenuProcess(responseData.strMenuProcessRight)
    SetMenuName(responseData.strMenuName)
    SetMenuCode(responseData.strMenuTag)
    setPermissionReasonShow(responseData.strMenuReasonShow)
    setHelpUrl(responseData.strHelpUrl)


    const { success, data } = await GetUserWiseLocations(LogUserType, Location);

    if (success) {
      setLocationList(data)
    } else {
      setLocationList([])
    }


  }, [])

  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]

    var menuDetail = await getMenuDetails(window.location.pathname)

    var menu =
      menuDetail && menuDetail.menuTag
        ? menuDetail.menuTag
        : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])



  //**Permission Check */
  const permission = operation => {
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: Location,
      strMenuCode: menuCode,
    }

    clearPermissionInputs() //clear username & password

    fetch(`${ApiURL}login/userpermission`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(permissiondata),
    })
      .then(Response => {
        if (Response.status == "200") {
          Response.json().then(responseData => {
            let Access = responseData.data.strMenuAccessRight
            let Create = responseData.data.strMenuCreateRight
            let Delete = responseData.data.strMenuDeleteRight
            let Modify = responseData.data.strMenuModifyRight
            let Print = responseData.data.strMenuPrintRight
            let Process = responseData.data.strMenuProcessRight

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {

                displayAlertMessage("danger", `This user don't have permisiion to ${(addNew == true ? "save " : " update ")} !`)
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage("danger", "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage("danger", "This user don't have permission to print !")
              }
            }
          })
        } else if (Response.status == "400") {
          setDisabled(false)
          setDisabledCode(false)
          clearPermissionInputs()
          displayAlertMessage("danger", "Oops something went wrong !")

        } else if (Response.status == "403") {
          setDisabled(false)
          setDisabledCode(false)
          clearPermissionInputs()
          displayAlertMessage("danger", "You have not Permission to make changes !")

        } else if (Response.status == "404") {
          setDisabled(false)
          setDisabledCode(false)
          clearPermissionInputs()
          displayAlertMessage("danger", "Password or User Name is Invalid !")

        } else {
          ClearItem()
        }
      })
      .catch(error => {
        console.log(error.message)
      })
  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }

  const handlesave = async () => {

    if (selectedLocation == "") {
      displayAlertMessage("danger", "Please select a location")
      return
    }

    if(referenceNo != "" && referenceType == ""){
      displayAlertMessage("danger", "Please select a reference type")
      return
    }

    if(referenceNo == "" && referenceType != ""){
      displayAlertMessage("danger", "Please enter a reference number")
      return
    }

    if (!file) {
      displayAlertMessage("danger", "Please select a file to upload")
      return
    }

    try {
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Uploading file...")
      const { success, message } = await handleUpload(file, selectedLocation, LogUserType, Location , referenceNo , referenceType)
      SetLoadingAlert(false)

      if (success) {
        displayAlertMessage("success", message)
        ClearItem()
      } else {
        displayAlertMessage("danger", message)
      }

    } catch (error) {
      SetLoadingAlert(false)
      displayAlertMessage("danger", error.message)
    }

  }


  // String or binary data would be truncated. The statement has been terminated.

  //Clear and Reset All Fields
  const ClearItem = () => {
    setMainExtCode("")
    setFile(null)
    inputref.current.value = ""
    setSelectedLocation("")
    setReferenceType("")
    setReferenceNo("")
  }

  //Toolbar Fucntions
  const handleNew = e => {
    //e.preventDefault()
    ClearItem()
    setShow(false)
    setSaveEnable(true)
  }


  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPAlert
                    confirm_both={sweetAlertShow}
                    title={menuName}
                    description={AlertDescription}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    onConfirm={() => {
                      setsweetAlertShow(false)
                      if (AlertConfirmOption == 1) {
                        if (
                          addNew == true && menuCreate == true && permissionReasonShow == false
                        ) {
                          handlesave()
                        } else if (
                          addNew == true && menuCreate == true && permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Created", true, true)
                        } else if (
                          addNew == false && menuModify == true && permissionReasonShow == false
                        ) {
                          handlesave()
                        } else if (
                          addNew == false && menuModify == true && permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Updated", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 2) {
                        handleEdit()
                      } else if (AlertConfirmOption == 3) {
                        history.push("/dashboard")
                      } else if (AlertConfirmOption == 4) {
                        handleNew()
                      } else if (AlertConfirmOption == 5) {
                        if (
                          addNew == false && menuDelete == true && permissionReasonShow == false
                        ) {
                          handleDelete()
                        } else if (
                          addNew == false && menuDelete == true && permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Deleted", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 6) {
                        if (
                          menuPrint == true && permissionReasonShow == false
                        ) {
                          setprintoptionShow(true)
                        } else if (
                          menuPrint == true && permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Printed", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      }
                    }}
                    onCancel={() => {
                      setsweetAlertShow(false)
                    }}
                  />
                  <DPPermission
                    confirm_both={permissionAlertShow}
                    title={menuName}
                    description={permissionAlertTitle}
                    showReason={permissionReasonShow}
                    nameDisable={permissionNameDisable}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    AlName={permissionName}
                    AlNameOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setPermissionName(val2)
                    }}
                    AlPassward={permissionPassword}
                    AlPasswardOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setPermissionPassword(val2)
                    }}
                    AlReason={Reason}
                    AlReasonOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setReason(val2)
                    }}
                    onConfirm={() => {
                      setPermissionAlertShow(false)
                      if (AlertConfirmOption == 1) {
                        permission("Save")
                      } else if (AlertConfirmOption == 5) {
                        permission("Delete")
                      } else if (AlertConfirmOption == 6) {
                        permission("Print")
                      }
                    }}
                    onCancel={() => {
                      setPermissionAlertShow(false)
                      clearPermissionInputs() //clear password and username

                    }}
                  />
                  <DPPrintOption
                    confirm_both={printoptionShow}
                    title={menuName}
                    showCancel={true}
                    cancelColor={"danger"}
                    onConfirmpdf={() => {

                      setprintoptionShow(false)
                    }}
                    onConfirmxcel={() => {

                      setprintoptionShow(false)
                    }}
                    onCancel={() => {
                      setprintoptionShow(false)
                    }}
                  />
                  <DPLoadingAlert
                    confirm_both={loadingAlert}
                    title={loadingAlertTitle}
                  />
                  <Row>
                    <DPTopToolBar
                      //Help Button
                      helpEnable={true}
                      helpClick={() => {
                        window.open(helpUrl)
                      }}
                      //Favorite Button
                      favoriteEnable={true}
                      favoriteClick={handleFavourite}
                      //New Button
                      newEnable={true}
                      newClick={() => {
                        setShowReason(false)
                        setAlertDescription(
                          "Do you wish to refresh the screen ?"
                        )
                        setAlertConfirmOption(4)
                        setsweetAlertShow(true)
                      }}
                      //Save Button
                      saveEnable={saveEnable}
                      saveClick={() => {
                        // AutoGenerateCode()
                        setShowReason(true)
                        setAlertDescription("Do you wish to save ?")
                        setAlertConfirmOption(1)
                        setsweetAlertShow(true)
                      }}
                      //ProcessButton
                      processEnable={false}
                      processClick={() => {
                        alert("Process")
                      }}
                      //Edit Button
                      editEnable={false}
                      editClick={() => {
                        setShowReason(false)
                        setAlertDescription("Do you wish to edit ?")
                        setAlertConfirmOption(2)
                        setsweetAlertShow(true)
                      }}
                      //Print Button
                      //Print Button
                      printEnable={true}
                      printClick={() => {
                        setReason("Printed")
                        setAlertDescription("Do you wish to Print ?")
                        setAlertConfirmOption(6)
                        setsweetAlertShow(true)
                      }}
                      //Delete Button
                      deleteEnable={false}
                      deleteClick={() => {
                        setReason("Deleted")
                        setShowReason(true)
                        setAlertDescription("Do you wish to delete ?")
                        setAlertConfirmOption(5)
                        setsweetAlertShow(true)
                      }}
                      //Exit Button
                      exitEnable={true}
                      exitClick={() => {
                        setAlertDescription("Do you wish to exit ?")
                        setAlertConfirmOption(3)
                        setsweetAlertShow(true)
                      }}
                    />
                    <TransactionGenerateTXNWithExcelContent
                      show={show}
                      disabled={disabled}
                      AlertColor={AlertColor}
                      AlertMsg={AlertMsg}
                      ErrorMsg={ErrorMsg}
                      menuName={menuName}
                      menuCode={menuCode}
                      mainExtCode={mainExtCode}
                      setMainExtCode={setMainExtCode}
                      extCode={extCode}
                      setMainExtCodeOnClick={e => { setMainExtCode(e["value"]) }}
                      logLocation={Location}
                      displayAlertMessage={displayAlertMessage}
                      inputref={inputref}
                      setFile={setFile}
                      file={file}
                      selectedLocation={selectedLocation}
                      locationList={locationList}
                      locationOnChange={(e) => { setSelectedLocation(e["value"]) }}
                      setReferenceNoOnChange={(e) => {
                        const myText = Text(e.target, 50, true, false, "any", false)
                        setReferenceNo(myText)
                      }}
                      referenceNo={referenceNo}
                      referenceType={referenceType}
                      setReferenceTypeOnChange={(e) => { setReferenceType(e["value"]) }}
                    />

                  </Row>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={
                          crDate != "1900-01-01 00:00:00"
                            ? crDate
                              ? crDate.replace("T", " ")
                              : ""
                            : ""
                        }
                        modifiedBy={mdBy}
                        modifiedOn={
                          mdDate != "1900-01-01 00:00:00"
                            ? mdDate
                              ? mdDate.replace("T", " ")
                              : ""
                            : ""
                        }
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default TransactionGenerateTXNWithExcel
